module.exports = __webpack_public_path__ + "static/media/close.d9f96b3c.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@adactive/adsum-modal-asia/src/close.svg
// module id = 193
// module chunks = 0